// extracted by mini-css-extract-plugin
export default {"cookiebanner":"cookieconsent_cookiebanner__oKON2","cookietext":"cookieconsent_cookietext__K-mM9","cookiebutton":"cookieconsent_cookiebutton__dF4ma"};